import { cn } from "./cn";
import { MARK, Mark } from "./Mark";

/** The mark and the heavy lowercase wordmark, `size` px tall. The mark's empty sides are trimmed so the gap and the left edge start at its ink. */
export function Logo({ size = 28, className }: { size?: number; className?: string }) {
  const mark = Math.round(size * 1.1);
  const trim = -Math.round((mark * MARK.inset) / 40);
  return (
    <span className={cn("inline-flex items-center text-ink", className)} style={{ gap: Math.round(size * 0.3) }}>
      <Mark size={mark} style={{ marginInline: trim }} />
      <span className="font-display font-extrabold leading-none tracking-[-0.045em]" style={{ fontSize: Math.round(size * 0.9) }}>
        headcount
      </span>
    </span>
  );
}
